<style>
  #MyListMenu li{
    list-style: none;
  }
  .Lvl2{
    margin: 10px 20px;
  }
</style>
<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Edit Representative </h5>


      <form [formGroup]="FormEditRepresentative" (submit)="SubmitRepresentative()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6" >
              <label for="exampleInputEmail1">Username</label>
              <input value="{{PreUserName}}" disabled style="font-weight: bolder;"  type="text" class="form-control"  >
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Password (only when setting a new password) </label>
            <input formControlName="Password" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched" class="form-text text-muted MyErrorRedColor">Enter a password (at least 8 characters, using uppercase and lowercase letters, a number, and a symbol).</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6" >
              <label for="exampleInputEmail1">Name</label>
              <input formControlName="FName" type="text" class="form-control"  placeholder="Type here...">
              <small *ngIf="!get_Form_FName().valid && get_Form_FName().touched" class="form-text text-muted MyErrorRedColor">Enter the first name.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Last Name</label>
            <input formControlName="LName" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_LName().valid && get_Form_LName().touched" class="form-text text-muted MyErrorRedColor">Enter the last name. </small>
          </div>
        </div>
        <br/>
        <hr/>
        <br/>
        <h5 class="card-title">System Menu Access</h5>
        <div style="margin: 50px;">

          <ul id="MyListMenu">
            <ng-container *ngFor="let lvl1 of Data_List_Menu">
              {{lvl1.title}}
              <li *ngFor="let item of lvl1.child">
                <input  type="checkbox" (change)="Data_List_Menu_Change(item)" [checked]="item.selected" [ngClass]="{'Lvl2':item.parent>0}" /> {{item.title}}
              </li>
            </ng-container>
        </ul>

        </div>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!FormEditRepresentative.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
        <button routerLink="/Representative" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>
